import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SidebarMenu from './SidebarMenu';
import ExhibitorProgress from '../exhibitor/ExhibitorProgress';
import './Sidebar.css';

const Sidebar = () => {
    const location = useLocation();
    const exhibitor = useSelector(state => state.exhibitor);
    const showProgress = location.pathname.startsWith('/cabinet/exhibitorview') ||
                         location.pathname.startsWith('/cabinet/exhibitoredit');

	return (
        <div className='Sidebar'>
            <SidebarMenu/>
            {(exhibitor && showProgress) && <ExhibitorProgress exhibitor={exhibitor} title={true} useClick={true}/>}
        </div>
	);
};

export default Sidebar;
